import { useCallback, useEffect, useState } from 'react';
import AppLayout from '../../../../component/appLayout';
import { Content } from './styles';
import IntegrationBox from '../../../../component/integrationBox';
import { isEmpty } from '../../../../helpers/common';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import { useMobileDevice } from '../../../../global/useMobile';
import { getCompanySettingIntegration } from '../../../../services/settingServices';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import { Group, Header, PersonalText, Container } from '../../styles';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ImageKey } from '../../../../component/image';

interface DataProps {
  title: string;
  description: string;
  isConnected?: boolean;
  isConnect?: boolean;
  isComingSoonTag?: boolean;
  isLearnMoreBtn?: boolean;
  IntegrationsLogoName?: ImageKey;
}
const integrationData: DataProps[] = [
  {
    IntegrationsLogoName: 'stripe_logo',
    title: 'Stripe',
    description: 'Allows your clients to pay your invoices with their credit card.',
    isConnected: false
  },
  {
    IntegrationsLogoName: 'figma_logo',
    title: 'Figma',
    description: 'Figma is a collaborative web application for interface design.',
    isConnect: false
  },
  {
    IntegrationsLogoName: 'github_logo',
    title: 'Github',
    description: 'Link to GitHub for collaborative development within projects.',
    isConnect: true
    // isComingSoonTag: true
  },
  // {
  //   IntegrationsLogoName: Images.vercel_logo,
  //   title: 'Vercel',
  //   description:
  //     'Connect Vercel to deploy, track builds, and view real-time deployment status directly within each task.',
  //   isConnect: true
  // },
  {
    IntegrationsLogoName: 'sentry_logo',
    title: 'Sentry',
    description: 'Connect Sentry to seamlessly create tasks from sentry dashboard.',
    isConnect: true
    // isComingSoonTag: true
  },
  {
    IntegrationsLogoName: 'zapier_logo',
    title: 'Zapier',
    description:
      'Zapier automates routine tasks, granting time to focus on critical work by eliminating manual effort.',
    isLearnMoreBtn: true
  },
  {
    IntegrationsLogoName: 'api_logo',
    title: 'Api',
    description: 'APIs enable applications to communicate, share data, and enhance functionalities seamlessly.',
    isLearnMoreBtn: true
  }
];

function Integrations() {
  // States
  const [data, setData] = useState<DataProps[]>(integrationData);
  // mobx states
  const { appStore, workspaceStore } = rootStore;
  const { themeMode } = appStore || {};
  const { currentWorkspace } = workspaceStore || {};
  // Other variables
  const isMobile = useMobileDevice();

  // Loads and updates integration data based on workspace settings
  const loadData = useCallback(async () => {
    if (!isEmpty(currentWorkspace?.id)) {
      const result = await getCompanySettingIntegration(currentWorkspace?.id);
      const updatedData = data?.map((x) => {
        if (x?.title === 'Stripe') {
          return { ...x, isConnected: result?.stripe_connected, isLearnMoreBtn: !result?.stripe_connected };
        } else if (x?.title === 'Figma') {
          return { ...x, isConnected: result?.figma_connected, isConnect: !result?.figma_connected };
        } else if (x?.title === 'Sentry') {
          return {
            ...x,
            isConnected: result?.sentry_connected,
            isConnect: !result?.sentry_connected
          };
        } else return x;
      });
      setData(updatedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeMode?.theme, currentWorkspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          <Group>
            {!isMobile ? (
              <Header>
                <PersonalText>Integrations</PersonalText>
              </Header>
            ) : (
              <ResponsiveHeader title='Integrations' />
            )}
            <Content>
              {data?.map((integration, index) => (
                <IntegrationBox
                  key={integration?.title}
                  IntegrationsLogoName={integration.IntegrationsLogoName}
                  title={integration.title}
                  description={integration.description}
                  isConnected={integration.isConnected}
                  isConnect={integration.isConnect}
                  isComingSoonTag={integration.isComingSoonTag}
                  isLearnMoreBtn={integration.isLearnMoreBtn}
                  isLast={index === data.length - 1}
                  loadData={loadData}
                />
              ))}
            </Content>
          </Group>
        </Container>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
}

export default observer(Integrations);
